import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import PreviewCertificate from "../pages/User/Certificate/PreviewCertificate/PreviewCertificate";
import CertificateList from "../pages/User/Certificate/CertificateList/CertificateList";
import Dashboard from "../pages/User/Dashboard/Dashboard";
import Profile from "../pages/User/Profile/Profile";

var NormalUserRoutes = [
   {
    path: "dashboard",
    name: "Dashboard",
    element: <Dashboard/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-profile",
    name: "My Profile",
    element: <Profile/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default NormalUserRoutes;
